import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import IntraInstitutionalReportView from "./IntraInstitutionalReportView";
import {ReportsService} from "../../../service/reports/ReportsService";
import ConfirmationMessage from "../../../components/confirmationMessage";


export default class IntraInstitutionalReportContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            isLoading: false,
            filters: {
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
            exportOptions: [
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
            disabledSearchButton: false,
        };

        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    onChangeFilters(event) {
        let filtersAux = this.state.filters;

        if (event.target.name === "startDate") {
            filtersAux[event.target.name] = event.target.value;
            filtersAux['finalDate'] = event.target.value;
        } else {
            filtersAux[event.target.name] = event.target.value;
        }

        this.setState({
            filters: filtersAux
        });
    }

    exportDocument() {
        this.loading(true);
        let params = {
            initialDate: this.state.filters.startDate.getFullYear() + "-" +
                (this.state.filters.startDate.getMonth() + 1) + "-" +
                this.state.filters.startDate.getDate(),
            finalDate: this.state.filters.finalDate.getFullYear() + "-" +
                (this.state.filters.finalDate.getMonth() + 1) + "-" +
                this.state.filters.finalDate.getDate()
        }
        if("CSV" === this.state.typeDocument){
            this.reportsService.getIntraInstitutionalReportCSV(params)
                .then(res => {
                    this.loading(false);
                });
        }
    }

    clearFilters() {
        this.setState({
            filters: {
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
        });
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataReport, isLoading,
            filters, exportOptions, disabledSearchButton
        } = this.state;

        return <IntraInstitutionalReportView
            dataReport={dataReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            filters={filters}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}
            onChangeFilters={this.onChangeFilters}
            clearFilters={this.clearFilters}
        />
    }
};